/* Puzzle, text photos and backgrounds share the stable remote-slot controller. */
(() => {
  const mounts = new WeakMap();
  const specs = {
    foto_rompecabezas: {
      category: 'puzzle',
      fallback: 1,
      title: 'foto_rompecabezas_title',
      alt: 'foto_rompecabezas_alt',
      example: 'https://cdn.shopify.com/s/files/1/0664/2673/2591/files/ROMPE_EJEMPLOOO.png?v=1767893271',
      exampleAlt: 'ejemplo_foto_rompecabezas',
      hint: 'tip_foto_rompecabezas',
      single: true
    },
    fotos_con_texto: {
      category: 'text_photos',
      fallback: 9,
      title: 'fotos_con_texto_title',
      alt: 'fotos_con_texto_label',
      exampleKey: 'fotos_con_texto',
      exampleAlt: 'ejemplo_fotos_con_texto',
      hint: 'tip_fotos_con_texto',
      captions: true
    },
    fotos_fondo: {
      category: 'backgrounds',
      fallback: 8,
      title: 'fotos_fondo_title',
      alt: 'fotos_fondo_label',
      example: 'https://cdn.shopify.com/s/files/1/0664/2673/2591/files/FONDOS_PARA_SHOPOFY.png?v=1767912415',
      exampleAlt: 'ejemplo_fotos_fondo',
      hint: 'tip_fotos_fondo'
    }
  };

  function required(step) {
    return step?.required === true || step?.required_if_enabled === true;
  }

  function get(state, step, key) {
    const spec = specs[key];
    const need = Number(step?.cantidad || spec.fallback);
    return window.TACFileSlots.get(state, {
      need,
      category: spec.category,
      extraDefaults: spec.captions ? { textos: '' } : {}
    });
  }

  function mount(body, step, key, onValidity) {
    window.TACPreviews?.unmount(body);
    mounts.get(body)?.();
    const spec = specs[key];
    if (!spec) throw new Error('unknown_media_step');
    const state = window.tacCustomizer.data[key] ||= {};
    const legacyFile = state.file instanceof File ? state.file : null;
    if (state.url?.startsWith('blob:')) URL.revokeObjectURL(state.url);
    delete state.file;
    delete state.url;
    const engine = get(state, step, key);
    const text = name => window.t('stamps_slot_' + name);

    const root = document.createElement('div');
    root.className = `fe-wrap tac-media-slots tac-media-slots--${spec.category}`;
    if (spec.example || spec.exampleKey) {
      const exampleUrl = window.tacExampleImg(spec.exampleKey || key, spec.example);
      const example = document.createElement('img');
      example.className = 'tac-media-example';
      if (exampleUrl) example.src = exampleUrl;
      else example.hidden = true;
      example.alt = window.t(spec.exampleAlt);
      example.loading = 'eager';
      example.decoding = 'async';
      example.fetchPriority = 'high';
      root.append(example);
    }
    const title = document.createElement('div');
    title.className = 'fe-title';
    title.textContent = window.t(spec.title, { req: required(step) ? ' ' + window.t('required_tag') : '' });
    const counter = document.createElement('div');
    counter.className = 'fe-counter';
    counter.setAttribute('aria-live', 'polite');
    const addButton = document.createElement('button');
    addButton.type = 'button';
    addButton.className = 'fe-btn fe-btn--primary';
    addButton.textContent = window.t(spec.single ? 'btn_upload_photo' : 'btn_upload_photos');
    const input = document.createElement('input');
    input.type = 'file'; input.accept = 'image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif'; input.multiple = !spec.single; input.hidden = true;
    const replacement = document.createElement('input');
    replacement.type = 'file'; replacement.accept = input.accept; replacement.hidden = true;
    const grid = document.createElement('div');
    grid.className = 'fe-grid tac-media-grid';
    const hint = document.createElement('div');
    hint.className = 'fe-hint'; hint.textContent = window.t(spec.hint);
    root.append(title, counter, addButton, grid, input, replacement, hint);
    body.replaceChildren(root);

    let replacementIndex = null;
    const rows = Array.from({ length: engine.need() }, (_, i) => {
      const item = document.createElement('div'); item.className = 'tac-media-item';
      const box = document.createElement('div'); box.className = 'fe-slot'; box.dataset.position = i + 1;
      const number = document.createElement('span'); number.className = 'fe-slot-index'; number.textContent = i + 1;
      const img = document.createElement('img'); img.alt = window.t(spec.alt, { i: i + 1 }); img.loading = 'lazy'; img.decoding = 'async';
      const label = document.createElement('span'); label.className = 'tac-stamp-status';
      const actions = document.createElement('div'); actions.className = 'tac-stamp-actions';
      const buttons = {};
      for (const action of ['replace', 'retry', 'remove']) {
        const button = document.createElement('button');
        button.type = 'button'; button.textContent = text(action); button.setAttribute('aria-label', `${text(action)} ${i + 1}`);
        button.onclick = () => action === 'replace' ? (replacementIndex = i, replacement.click()) : engine[action](i);
        buttons[action] = button; actions.append(button);
      }
      box.append(number, img, label, actions); item.append(box);
      let caption = null;
      if (spec.captions) {
        caption = document.createElement('textarea'); caption.className = 'fct-text'; caption.rows = 2; caption.maxLength = 80;
        caption.placeholder = window.t('fotos_con_texto_placeholder_texto'); caption.value = state.textos[i] || '';
        caption.setAttribute('aria-label', `${window.t('fotos_con_texto_placeholder_texto')} ${i + 1}`);
        caption.oninput = () => { state.textos[i] = caption.value; window.tacDraftScheduleSave?.({ reason: 'text-photo-caption' }); };
        item.append(caption);
      }
      grid.append(item);
      const privatePreview = window.TACPreviews?.mount(root, img, {
        remote: () => state.remotes[i], url: () => state.urls[i], setURL: url => { state.urls[i] = url; }, localBlob: () => state.previewFiles[i], releaseLocal: () => { state.previewFiles[i] = null; }
      });
      return { box, img, label, buttons, caption, privatePreview };
    });
    addButton.onclick = () => input.click();
    input.onchange = () => { engine.add(input.files); input.value = ''; };
    replacement.onchange = () => { if (replacement.files[0]) engine.replace(replacementIndex, replacement.files[0]); replacement.value = ''; };
    let unsubscribe = () => {};
    function update() {
      if (!root.isConnected || !body.contains(root)) { unsubscribe(); return; }
      counter.textContent = text('count').replace('{got}', engine.verifiedCount()).replace('{need}', engine.need());
      rows.forEach(({ box, img, label, buttons, caption, privatePreview }, i) => {
        const value = state.uploadStatus[i]; const has = !!(state.files[i] || state.remotes[i]); const busy = engine.busy(i);
        box.dataset.status = value;
        if (state.urls[i] && img.getAttribute('src') !== state.urls[i]) img.src = state.urls[i];
        if (!state.urls[i]) img.removeAttribute('src'); img.hidden = !state.urls[i];
        privatePreview?.refresh();
        label.textContent = state.errors[i] ? text(state.errors[i]) : text(value);
        buttons.retry.hidden = value !== 'failed' || !state.files[i]; buttons.replace.hidden = !state.remotes[i]; buttons.remove.hidden = !has;
        for (const button of Object.values(buttons)) button.disabled = busy;
        if (caption) caption.disabled = !has;
      });
      onValidity(!required(step) || engine.complete());
    }
    unsubscribe = engine.subscribe(update); mounts.set(body, unsubscribe); update();
    if (typeof document !== 'undefined' && typeof document.dispatchEvent === 'function' && typeof CustomEvent === 'function') document.dispatchEvent(new CustomEvent('tac:file-slots', { detail: { category: spec.category, state, need: engine.need(), verified: engine.verifiedCount(), statuses: Array.from(state.uploadStatus || []).slice(0, engine.need()) } }));
    if (legacyFile) engine.add([legacyFile]);
    return engine;
  }

  window.TACMediaSlots = {
    mount,
    get,
    async clear(state, key) {
      if (!state) return true;
      const engine = get(state, { cantidad: Number(state.expected || specs[key].fallback) }, key);
      for (let i = engine.need() - 1; i >= 0; i--) {
        if ((state.files?.[i] || state.remotes?.[i]) && !(await engine.remove(i))) return false;
      }
      return true;
    },
    complete: (state, step, key) => !required(step) || window.TACFileSlots.complete(state, Number(step?.cantidad || specs[key].fallback)),
    count: state => window.TACFileSlots.count(state),
    specs
  };
})();
